import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { PageKind, UiModeType, } from 'jk-service';
import { StkmeService, templateUrlConfigStk } from './../_service_stk';
//import { Stkpi13DetailComponent } from './stkpi13-detailPkg.component';
import { StkmeEditComponent, } from './../_edit_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';


@Component({
  selector: 'app-stkpi13',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: templateUrlConfigStk.stkpi13,
  styleUrls: [],
})
export class Stkpi13Component extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi13';
  constructor() {
    super();
    this.srv = new StkmeService();
    this.pageKind = PageKind.master;
    this.uiMode = UiModeType.dialog;
    this.title = '群組設定建立作業';
    this.gridInitOpt = { programId: this.programId, sortField: 'ME001', sort: 'asc', defaultSort: null, pageKind: PageKind.bill };
    this.qbeConfig.addField = 'ME002,ME003,ME004';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = StkmeEditComponent;


    this.constructorInit();
  }

  /*
  override getLookup() {
    super.getLookup();
  }

  override constructorInit() {
    super.constructorInit();
  }
  */


}
